import React from "react";

const typologiesListColumn = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Label fr",
    dataIndex: "label_fr",
    key: "label_fr",
  },
  {
    title: "Enseigne ID",
    dataIndex: "retailer_id",
    key: "retailer_id",
  },
  {
    title: "Enseigne label",
    dataIndex: "retailer_label",
    key: "retailer_label",
    render: (text, record, index) => {
      const { retailer_label } = record;

      return (retailer_label.map((retailerLabel, index) =>
        <span>{retailerLabel} {index < retailer_label.length - 1 ? ',' : ''} </span>))
    }
  },
];

export default typologiesListColumn;


// WEBPACK FOOTER //
// src/containers/admin/typologies/TypologiesList.utils.js